// React
import React from "react";

// React Router
import { Link } from 'react-router-dom';

// Components
import { Footer } from '../../Components';

// Styles
import './beta.css';

export const Beta = () => {

    return (
        <React.Fragment>
        <div id='Beta'>
            <div className='beta-logo'>
                <img src="./assets/img/logo.svg" alt='Yety Logo'/>               
            </div>
            <div className='beta-header'>
                Welcome to the Yety Beta!          
            </div>
            <div className='beta-details'>
                <div className='beta-box'>
                    <div className='beta-box-title'>
                        What We Hope To Accomplish
                    </div>
                    <div className='beta-box-content'>
                        <ul>
                            <li>1. Get feedback from our early users.  What did you like? What could be better?  What is Yety missing?</li>
                            <li>2. Gain insight on our early user's behaviour in the app.  Which features are being used the most and which are being used the least. </li>
                            <li>3. Catch a few bugs. And then catch some more bugs.  Hopefully catch all the bugs. </li>
                            <li>4. Continually improve the app during the course of the beta. We will work day and night to make the changes you want and fix the bugs you find.</li>
                        </ul>
                    </div>
                </div>
                <div className='beta-box'>
                    <div className='beta-box-title'>
                        How You Can Help
                    </div>
                    <div className='beta-box-content'>
                        <ul>
                            <li>1. <Link to='/login' className='beta-link blue'>Sign Up!</Link>  Give the app a try. Find things you like and other things you don't, but most importantly, let us know! </li>
                            <li>2. Join Our <a href="https://join.slack.com/t/yety-community/shared_invite/enQtMzQ0NDAxNzE2MDE2LWI3ZGU4OTA0ZDU2ZTQxOTM3NDExMzgxNDNjODhkMjFjYzQ2ZDlmNTRjNDg4ZDZhOTY5ZjM0M2M4OWVlZjNhZmE" className='beta-link purple'>Slack Community</a> and share your feedback directly with the Yety team and other users. </li>
                            <li>3. Share the app with your friends!  If you like Yety and your friend's might like Yety, why not let them know.  You can find links to all of our social pages below.</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <Footer />
        </React.Fragment>
    );

};

export default Beta;


// WEBPACK FOOTER //
// ./src/Views/InfoPages/Beta.js